export default __webpack_public_path__ + "static/media/bitstop-app-layout-2.efd4d2d0.png";